
import { lookupCustomer } from '@/api';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserDataAdvancedJB } from '@/models/main';
import LookupCustomerCode from '@/components/jobBooking/AdvancedJobBooking/LookupCustomerCode.vue';
import { clearPhoneNumber } from '@/utils/InputProcessingUtilities';
import CustomerCodeSelect from '@/components/dashBoard/selectsFields/CustomerCodeSelect/CustomerCodeSelect.vue';

@Component({
  components: {
    LookupCustomerCode,
    CustomerCodeSelect,
  },
})
export default class CustomerDetailsFieldGroup extends Vue {
  @Prop(Object) public readonly userData: UserDataAdvancedJB;
  @Prop({ type: Boolean, required: false }) public readonly customerCodeIsRequired!: boolean;
  @Prop(Function) public setCustomerCode: (customerCode: string, stop_number?: number) => void;

  public autocompleteCustomer = lookupCustomer;

  public handleBlur() {
    this.userData.phone_number = clearPhoneNumber(this.userData.phone_number);
  }

  public onlyNumberAndSpace($event) {
    const keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 32 && keyCode !== 40 && keyCode !== 41) {
      $event.preventDefault();
    }
  }
}
